export enum FullTextStatus {
  NotProcessed = 0,
  Successful = 1,
  Failed = 2,
  PostProcessSuccessful = 3,
  PostProcessFailed = 4,
  MailroomSuccessful = 5,
  MailroomFailed = 6,
  BarcodeIndexingSuccessful = 7,
  BarcodeIndexFailed = 8,
  PdfCombinePending = 9,
  PdfCombineFailed = 10
}